import { render, staticRenderFns } from "./TopicDropdownDesktop.vue?vue&type=template&id=55bf462a&scoped=true&"
import script from "./TopicDropdownDesktop.vue?vue&type=script&lang=js&"
export * from "./TopicDropdownDesktop.vue?vue&type=script&lang=js&"
import style0 from "./TopicDropdownDesktop.vue?vue&type=style&index=0&id=55bf462a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf462a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VListItem,VSelect})
